import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Ydelser from "@/pages/Ydelser";
import Projekter from "@/pages/Projekter";
import Om from "@/pages/Om";
import Kontakt from "@/pages/Kontakt";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/ydelser" element={<Ydelser />} />
                        <Route path="/projekter" element={<Projekter />} />
                        <Route path="/om" element={<Om />} />
                        <Route path="/kontakt" element={<Kontakt />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="top-center" />
            </BrowserRouter>
        </div>
    );
}

export default App;
